import { TACTICAL_ACTIONS } from '../../shared/game/tactical-types.js';
import { berserker } from './berserker.js';
import { cheat } from './cheat.js';
import { commander } from './commander.js';
import { hunter } from './hunter.js';
import { oathsworn } from './oathsworn.js';
import { mage } from './mage.js';
import { shadowmancer } from './shadowmancer.js';
import { shepherd } from './shepherd.js';
import { songweaver } from './songweaver.js';
export { berserker, cheat, commander, hunter, mage, oathsworn, shadowmancer, shepherd, songweaver };
export const classCatalog = [commander, hunter, songweaver, cheat, shepherd, shadowmancer, berserker, mage, oathsworn];

/** Behavior settings that switch every autocast off, for scenarios and tests that drive heroes by hand. */
export const NO_AUTOCAST = {
  autocastOff: [...classCatalog.flatMap(cls => cls.abilities).filter(ability => ability.autocast && !ability.autoAttack), ...TACTICAL_ACTIONS.filter(action => action.autocast)].map(ability => ability.id),
  autoAttack: null, inspiration: false,
};
